import { TooltipProvider } from "@/components/ui/tooltip";
import { router } from "@/router";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react18-json-view/src/style.css";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";

import "./index.css";

//
if (import.meta.env.DEV_MODE !== "true") {
  Sentry.init({
    dsn: "https://6721d3804e8c7750991e509b6c407bf6@o4505132112543744.ingest.us.sentry.io/4512015373107200",
    sendDefaultPii: true,
  });
}

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <RouterProvider router={router} />
    </TooltipProvider>
    <Toaster richColors position="top-right" />
  </QueryClientProvider>,
);
